import { useFirestore, useFirestoreCollectionData, useUser } from 'reactfire'
import { collection, query, where } from 'firebase/firestore'

export function useUnreadNotificationCount({ dismissableOnly = false } = {}) {
  const firestore = useFirestore()
  const user = useUser()

  const { data: unreadNotifications } = useFirestoreCollectionData(
    query(
      collection(firestore, 'notifications'),
      where('userUids', 'array-contains', user.data.uid),
      where('dismissedAt', '==', null)
    ),
    { idField: 'uid' }
  )
  if (dismissableOnly) {
    return unreadNotifications?.filter((n) => n.userDismissable).length || 0
  }
  return unreadNotifications?.length || 0
}
